import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Menu from "../../components/menu/Menu";
import MenuGeral from "../../components/menu/MenuGeral";

import Loader from "../../utils/Loader";

import { getDataValidade } from "../../services/dataValidadeService";

function Outros() {

  const navigate = useNavigate();

  let decoded = null;
  const isAuth = localStorage.getItem("token") !== null;
  if (isAuth) decoded = jwtDecode(localStorage.getItem("token"));

  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(true);

  const [dataValidade, setDataValidade ] = useState([]);
  const [dataValidadeHoje, setDataValidadeHoje ] = useState([]);
  const [dataValidadeOntem, setDataValidadeOntem ] = useState([]);


  useEffect(() => {  
    const token = localStorage.getItem("token");

    setIsLoading(true);

    getDataValidade(token)
      .then((response) => {
        setDataValidade(response);

	let hoje = new Date();
	const dd = String(hoje.getDate()).padStart(2, '0');
	const mm = String(hoje.getMonth() + 1).padStart(2, '0'); // Janeiro is 0!
	const yyyy = hoje.getFullYear();

	hoje = yyyy + '-' + mm + '-' + dd;
   
        setDataValidadeHoje(response.filter(d => d.dataONLY === hoje));
        setDataValidadeOntem(response.filter(d => d.dataONLY !== hoje));

        //console.log(dataValidadeHoje);
        //console.log(dataValidadeOntem);

        setIsLoading(false);
        
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) return navigate("/");

        //setError(err.response ? err.response.data : err.message);
        setIsLoading(false);
      });

  }, [refresh]);

  // console.log("DEBUG: ", dataValidadeHoje);

  return (
    <>
      { decoded && decoded.isAdmin ? <Menu /> : <MenuGeral />}
      <main className="content">
        {isLoading ? (
          <Loader />
        ) : (
          <>

            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
              <div className="d-block mb-md-0">
                <h1 className="h4">Outros</h1>
              </div>
              <div>
                <button
                  onClick={() => {
                    setRefresh((r) => !r);
                  }}
                >
                  Atualizar
                </button>
              </div>
            </div>


          <div className="card card-body border-0 shadow mt-2 mb-2">
            <h5 className="h6 fw-bold">Alterações à data de validade, hoje (#{dataValidadeHoje.length})</h5>

            <div className="row mt-4">
            {
              dataValidadeHoje.length > 0 && dataValidadeHoje.map(d => {
                {/*console.log("? ", d.data_validade_old)*/}
                return (
                  <div key={d.cod_hist_alt} className="col-12 col-sm-6 col-xl-3">
                    {/*<div className="card card-body border-0 shadow mt-2 mb-2">*/}
                    <div className="card card-body py-3 border-2 mt-2 mb-2">
                      <div>
                       <p style={{marginBottom: ".5rem", backgroundColor: "rgba(240, 188, 116, 0.3)", textAlign : "center", borderRadius: "5px"}}>Instante: {d.data_alteracao}{" "}</p>
                       <p style={{marginBottom: ".5rem", textAlign : "right"}}>Colaborador: {d.operador}{" "}</p>
                       <p style={{marginBottom: ".5rem"}}><strong>{d.codigo}</strong>{" - "}<span style={{fontSize: ".75rem"}}>{d.nome_atleta}</span></p>
                       <p style={{marginBottom: ".5rem"}}>Data: {d.data_validade_old ? <span style={{textDecoration: "line-through"}}>{d.data_validade_old}</span> : <span style={{textDecoration: "line-through"}}>{d.data_inicio}</span>}{" - "}{d.data_validade_act}</p>
                       {d.estado_anterior !== d.estado_actual && <p style={{marginBottom: ".5rem"}}>Estado: {d.estado_anterior}{" - "}{d.estado_actual}</p>}
                       {d.meses !== 0 && <p className="mb-0">Período: {d.meses}</p>}
                      </div>
                    </div>
                  </div>
                )
              })
            }
            </div>
          </div>

          <div className="card card-body border-0 shadow mb-2">
            {/*<h4 className="h5 mb-1">Alterações à data de validade, ontem ({dataValidadeOntem.length})</h4>*/}
            <h5 className="h6 fw-bold">Alterações à data de validade, ontem (#{dataValidadeOntem.length})</h5>

            <div className="row mt-4">
              {dataValidadeOntem.length > 0 && dataValidadeOntem.map(d => {
                {/*console.log("? ", d.dataValidadeOntem)*/}
                return (
                  <div key={d.cod_hist_alt} className="col-12 col-sm-6 col-xl-3">
                   <div style={{backgroundColor: "#f2f2f2"}} className="card card-body border-2 mt-2 mb-2">
                     <div>
                       <p style={{marginBottom: ".5rem", backgroundColor: "rgba(240, 188, 116, 0.3)", textAlign : "center", borderRadius: "5px"}}>Instante: {d.data_alteracao}{" "}</p>
                       <p style={{marginBottom: ".5rem", textAlign : "right"}}>Colaborador: {d.operador}{" "}</p>
                       <p style={{marginBottom: ".5rem"}}><strong>{d.codigo}</strong>{" - "}<span style={{fontSize: ".75rem"}}>{d.nome_atleta}</span></p>
                       <p style={{marginBottom: ".5rem"}}>Data: {d.data_validade_old ? <span style={{textDecoration: "line-through"}}>{d.data_validade_old}</span> : <span style={{textDecoration: "line-through"}}>{d.data_inicio}</span>}{" - "}{d.data_validade_act}</p>
                       {d.estado_anterior !== d.estado_actual && <p style={{marginBottom: ".5rem"}}>Estado: {d.estado_anterior}{" - "}{d.estado_actual}</p>}
                       {d.meses !== 0 && <p className="mb-0">Período: {d.meses}</p>}
                     </div>
                   </div>
                 </div>)
                })
              }
            </div>
          </div>
          </>
        )}
      </main>
    </>
  );
}

export default Outros;
